export const badgeVariants = ['blue', 'lime', 'light'] as const
export const badgeSize = ['small', 'medium'] as const
